/**
 * Custom Free Shipping Bar v7 (Fix Visibility)
 * Corrige el problema de que la barra principal no se mostraba.
 */

class FreeShippingManager {
  constructor() {
    this.init();
  }

  init() {
    // 1. Cargar estado inicial
    this.refreshAllBars();

    // 2. Escuchar clics GLOBALMENTE (Delegación de eventos)
    document.body.addEventListener('click', (e) => {
      const trigger = e.target.closest('.zone-switch-item');
      // Si el clic fue en un switch y NO en un enlace de políticas
      if (trigger && !e.target.closest('.zone-policy-link')) {
        e.preventDefault();
        const zoneName = trigger.dataset.zoneName;
        this.changeZone(zoneName);
      }
    });

    // 3. Escuchar cambios en el carrito
    document.addEventListener('cart:updated', () => this.fetchCart());
    
    // 4. Interceptar Fetch
    this.interceptFetch();

    // 5. Observer para detectar cambios en el DOM (mini cart abriéndose)
    this.observeDomChanges();
  }

  changeZone(zoneName) {
    localStorage.setItem('shipping_zone_preference', zoneName);
    this.updateActiveClasses(zoneName);
    this.fetchCart();
  }

  fetchCart() {
    fetch(window.Shopify.routes.root + 'cart.js')
      .then(r => r.json())
      .then(cart => {
        this.updateAllBarsData(cart.total_price);
      })
      .catch(e => console.error('Error shipping bar:', e));
  }

  refreshAllBars() {
    this.fetchCart();
    const currentZone = localStorage.getItem('shipping_zone_preference');
    if (currentZone) {
      this.updateActiveClasses(currentZone);
    }
  }

  updateAllBarsData(totalPrice) {
    // Seleccionamos TODAS las barras (arriba y mini cart)
    const bars = document.querySelectorAll('.custom-free-shipping-bar');
    const savedZone = localStorage.getItem('shipping_zone_preference');

    bars.forEach(bar => {
      // Determinar qué zona usar
      let activeItem = null;
      const switches = bar.querySelectorAll('.zone-switch-item');
      
      if (savedZone) {
        activeItem = Array.from(switches).find(item => item.dataset.zoneName === savedZone);
      }
      
      if (!activeItem && switches.length > 0) {
        activeItem = switches[0];
      }

      if (activeItem) {
        // --- CORRECCIÓN V7: Asegurar que la barra sea VISIBLE ---
        bar.style.display = 'block';
        // --------------------------------------------------------

        // Asegurar que visualmente esté activo el switch correcto
        this.updateActiveClasses(activeItem.dataset.zoneName);
        
        // Calcular lógica
        const threshold = parseInt(activeItem.dataset.threshold, 10);
        const suffix = activeItem.dataset.successSuffix || '';
        const msgUnder = bar.dataset.messageUnder;
        const msgAt = bar.dataset.messageAt;
        const textEl = bar.querySelector('.custom-free-shipping-bar__text');

        const remaining = threshold - totalPrice;

        if (remaining <= 0) {
          // META CUMPLIDA
          textEl.innerHTML = `${msgAt} <span style="font-weight:700">${suffix}</span>`;
        } else {
          // FALTA DINERO
          const formattedMoney = '$' + (remaining / 100).toLocaleString('es-CL');
          const finalMsg = msgUnder.replace('[monto]', `<strong>${formattedMoney}</strong>`);
          textEl.innerHTML = finalMsg;
        }
      }
    });
  }

  updateActiveClasses(zoneName) {
    const allSwitches = document.querySelectorAll('.zone-switch-item');
    allSwitches.forEach(item => {
      if (item.dataset.zoneName === zoneName) {
        item.classList.add('active');
      } else {
        item.classList.remove('active');
      }
    });
  }

  interceptFetch() {
    const originalFetch = window.fetch;
    window.fetch = function() {
      return originalFetch.apply(this, arguments).then((response) => {
        if (response.url.includes('/cart/add') || 
            response.url.includes('/cart/change') || 
            response.url.includes('/cart/update') ||
            response.url.includes('section_id')) { 
           setTimeout(() => document.dispatchEvent(new Event('cart:updated')), 500);
        }
        return response;
      });
    };
  }

  observeDomChanges() {
    const observer = new MutationObserver((mutations) => {
      let shouldUpdate = false;
      mutations.forEach(mutation => {
        if (mutation.addedNodes.length) {
          shouldUpdate = true;
        }
      });
      if (shouldUpdate) {
        if(this.debounceTimer) clearTimeout(this.debounceTimer);
        this.debounceTimer = setTimeout(() => this.refreshAllBars(), 300);
      }
    });

    observer.observe(document.body, { childList: true, subtree: true });
  }
}

document.addEventListener('DOMContentLoaded', () => {
  window.freeShippingManager = new FreeShippingManager();
});